<template>
  <div class="dados-sanguineos-details">
    <page-header :title="title" />
    <page-section>
      <v-row no-gutters>
        <v-col class="mb-4" cols="12">
          <field-section
            :label="$t('Tipo_Sangue')"
            :value="tag.tipoSangue"
            :is-restrict="
              $store.getters['tagFuncionario/isRestrict']('tipoSangue')
            "
          />
        </v-col>
        <v-col class="mb-4" cols="12" md="6">
          <field-section
            :label="$t('Aceita_Transfusao_Sangue')"
            :value="tag.aceitaTransfusaoSangue"
            :is-restrict="
              $store.getters['tagFuncionario/isRestrict'](
                'aceitaTransfusaoSangue'
              )
            "
          >
            <template #value>
              {{ convert(tag.aceitaTransfusaoSangue) }}
            </template>
          </field-section>
        </v-col>
        <v-col class="mb-4" cols="12" md="6">
          <field-section
            :label="$t('Doador_Orgaos')"
            :value="tag.doadorOrgaos"
            :is-restrict="
              $store.getters['tagFuncionario/isRestrict']('doadorOrgaos')
            "
          >
            <template #value>
              {{ convert(tag.doadorOrgaos) }}
            </template>
          </field-section>
        </v-col>
        <v-col class="mb-4">
          <field-section
            :label="$t('medicacao_anti_coagulo')"
            :value="tag.usaMedicacaoAntiCoagulo"
            :is-restrict="
              $store.getters['tagFuncionario/isRestrict'](
                'usaMedicacaoAntiCoagulo'
              )
            "
          >
            <template #value>
              {{ convert(tag.usaMedicacaoAntiCoagulo) }}
            </template>
          </field-section>
        </v-col>
      </v-row>
    </page-section>
    <Form :title="title" :data="tag" />
  </div>
</template>

<script>
import i18next from "i18next";
import PageHeader from "@/components/headers/page-header";
import PageSection from "@/components/sections/page-section";
import FieldSection from "@/components/sections/field-section";
import Form from "./form";
export default {
  metaInfo: {
    titleTemplate: (i18next.t("Dados_Sanguineos") || "") + " | %s",
  },
  components: { FieldSection, PageSection, PageHeader, Form },
  data: () => ({
    title: i18next.t("Dados_Sanguineos"),
  }),
  computed: {
    tag() {
      return this.$store.state.tagFuncionario.data || {};
    },
    convert() {
      return (value) => (value ? this.$t("Sim") : this.$t("Nao"));
    },
  },
};
</script>

<style scoped></style>
